import ISupportTicketCategory from "../models/ISupportTicketCategory";

export enum SupportTicketCategoryType {
  SupportTicket = "SupportTicket",
  ServiceRequest = "ServiceRequest",
}

export default interface ISupportTicketCategoryRepository {
  get(token: string, type: SupportTicketCategoryType): Promise<ISupportTicketCategory[]>;
}
